import dayjs from './dayjs.util';
import duration from 'dayjs/plugin/duration';
import {
  HumanizeDurationLanguage,
  HumanizeDuration,
} from 'humanize-duration-ts';

dayjs.extend(duration);
interface Time {
  hours: number;
  minutes: number;
  seconds: number;
}

const zeroPad = (num: number) => String(num).padStart(2, '0');

export const replaceTime = (
  text: string,
  { hours, minutes, seconds }: Time,
  replace = '%s',
) =>
  text.replace(
    replace,
    `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`,
  );

export const getTimerAction = (
  title: string,
  { hours, minutes, seconds }: Time,
  onClose: () => void,
  setTitle: (value: string) => void,
) => {
  let duration = dayjs.duration({ hours, minutes, seconds });

  return () => {
    duration = dayjs.duration(duration.asSeconds() - 1, 'seconds');

    hours = duration.hours();
    minutes = duration.minutes();
    seconds = duration.seconds();

    if (hours <= 0 && minutes <= 0 && seconds <= 0) {
      onClose();
    } else {
      setTitle(replaceTime(title, { hours, minutes, seconds }));
    }
  };
};

export const minutesHumanize = (minutes: number) => {
  const duration = new HumanizeDuration(new HumanizeDurationLanguage());
  return duration.humanize(minutes * 60000, {
    language: 'pt',
    delimiter: ' e ',
  });
};
